module.exports = __webpack_public_path__ + "01_very_short_brown.b545e683.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer5/01_very_short_brown.png
// module id = C/td
// module chunks = 0